<template>
  <div class="form-group mb-2 label-select2" v-bind="$attrs">
    <div class=""> <!-- ✅ wrapper extra igual que SoftField -->
      <label v-if="useLabel" :for="id" class="form-label">
        {{ label }}
      </label>

      <select
        :id="id"
        class="form-control"
        :value="castValue(modelValue)"
        :name="name"
        :disabled="disabled"
        @change="$emit('update:modelValue', castValue($event.target.value))"
      >
        <option value="0">{{ placeholder }}</option>
        <option v-for="valor in valores" :key="valor.id" :value="valor.id">
          {{ valor.nombre }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: "SoftSelect",
  inheritAttrs: false,
  props: {
    id: { type: String, required: true },
    placeholder: { type: String, default: "Seleccione..." },
    name: { type: String, default: "" },
    valores: { type: Array, default: () => [] },
    modelValue: { type: [String, Number], default: "" },
    useLabel: { type: Boolean, default: false },
    label: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    cast: { type: String, default: "number" }, // "number" | "string"
  },
  emits: ["update:modelValue"],
  methods: {
    castValue(v) {
      if (this.cast === "string") return String(v ?? "");
      // default: number
      const n = Number(v);
      return Number.isNaN(n) ? 0 : n;
    }
  },

};
</script>

<style scoped>
/* NO layout aquí. Solo evitamos flechas “fake” del theme */
select.form-control{
  background-image:none !important;
  appearance:auto !important;
  -webkit-appearance:auto !important;
  -moz-appearance:auto !important;
}

.form-group::after,
.label-select2::after{
  content:none !important;
  display:none !important;
}
/* Skin Quanty */
select.form-control{
  background-color: var(--q-hover);
  border-color: var(--q-border-md);
  color: var(--q-text);
  border-radius:10px;
}
select.form-control:focus{
  border-color: var(--q-gold);
  box-shadow: 0 0 0 3px rgba(245,166,35,0.2);
  outline:none;
}
</style>